import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import KeysAddressSection from '@/orderDetails/KeysAddressSection';
import AccessInformationIcon from '@/svg-icons/AccessInformation';

const AccessInformationSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <AccessInformationIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0 align-middle" />
      <FormattedMessage id="accessInformation" />
    </div>

    <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)] gap-4">
      {!!data.type && (
        <div className="flex flex-col" data-cy="order-details-access-info-type">
          <div className="font-bold">
            <FormattedMessage id="keysLocationRadio" />
          </div>
          <FormattedMessage id={data.type} />
          {(data.type === 'Outro' || data.type === 'Na imobiliária') && !!data.address && (
            <div className="mt-2">
              <KeysAddressSection address={data.address} />
            </div>
          )}
        </div>
      )}

      {!!data.keysDevolutionType && (
        <div className="flex flex-col" data-cy="order-details-access-info-type">
          <div className="font-bold">
            <FormattedMessage id="keysDevolutionType" />
          </div>
          <FormattedMessage id={data.keysDevolutionType} />
          {(data.keysDevolutionType === 'Outro' || data.keysDevolutionType === 'Na imobiliária') && !!data.keysDevolutionAddress && (
            <div className="mt-2">
              <KeysAddressSection address={data.keysDevolutionAddress} />
            </div>
          )}
        </div>
      )}

      {!!data.keysLocation && (
        <div className="flex flex-col" data-cy="order-details-keys-location">
          <div className="font-bold">
            <FormattedMessage id="keysLocation" />
          </div>
          {data.keysLocation}
        </div>
      )}

      <div className="flex flex-col" data-cy="order-details-extra-instructions">
        <div className="font-bold">
          <FormattedMessage id="extraInstructions" />
        </div>
        {data.extraInstructions === true ? <FormattedMessage id="Yes" /> : <FormattedMessage id="No" />}
      </div>

      {!!data.extraInstructions && (
        <div className="flex flex-col" data-cy="order-details-keys-location">
          <div className="font-bold">
            <FormattedMessage id="instructions" />
          </div>
          {data.instructions}
        </div>
      )}
    </div>
  </div>
);

AccessInformationSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AccessInformationSection;
